import React from 'react';

const FlexContainer = ({ tw, children }) => {
  return <div className={`flex ${tw}`}>{children}</div>;
};

export default FlexContainer;
